// CZNA-1513 — MCL keeps a clicked row in place across a layout change: on mousedown it
// notes the row, and once columns are re-measured it scrolls by how far the row moved.
// Opening the detail pane narrows the register, MCL re-positions its virtualized rows,
// and it measures the clicked row while that row is still parked at the end of the list —
// so it scrolls there, the rows on screen vanish and further pages load. A selector that
// matches nothing turns the correction off; the scroll position already holds the row.
export var NO_ITEM_TO_VIEW = { selector: '[data-czna-no-item-to-view]', localClientTop: 0 };
